'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        fontFamily: palette.fontFamily,
        fontSize: palette.tsNormal,
        lineHeight: palette.tlNormal,

        tabsJustifyContent: 'flex-start',
        tabsAlignItems: 'flex-end',

        tabJustifyContent: 'flex-start',
        tabAlignItems: 'center',
        tabMarginRight: palette.gutter * 3 + 'px',
        tabBorderWidth: '3px',
        tabBorderStyle: 'solid',
        tabBorderColor: 'transparent',
        tabPaddingTop: palette.gutter * 3 + 'px',
        // gutter * 3 - border-width
        tabPaddingBottom: '21px',
        tabPaddingLeft: 0,
        tabPaddingRight: 0,
        tabColor: palette.tInactive,
        tabFontSize: palette.tsNormal,
        tabLineHeight: 1.5,
        tabFontWeight: palette.twNormal,
        tabCursor: 'normal',

        activeTabBorderWidth: '3px',
        activeTabBorderStyle: 'solid',
        activeTabBorderColor: palette.elAccent,
        activeTabFontSize: palette.tsNormal,
        activeTabLineHeight: 1.5,
        activeTabFontWeight: palette.twNormal,
        activeTabCursor: 'pointer',
        activeTabColor: palette.tFilled,

        hoverTabBorderWidth: '3px',
        hoverTabBorderStyle: 'solid',
        hoverTabBorderColor: palette.elDarkest,
        hoverTabFontSize: palette.tsNormal,
        hoverTabLineHeight: 1.5,
        hoverTabFontWeight: palette.twNormal,
        hoverTabCursor: 'pointer',
        hoverTabColor: palette.tFilled
    };
};